import LoadingIndicator from "components/shared/LoadingIndicator";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useGetCmsPageQuery } from "store/services/cms";
import parse from "html-react-parser"

const TermsAndConditions = () => {

    const { data, isLoading, isFetching } = useGetCmsPageQuery("terms_conditions");

    return (
        <>
            <section className="client position-relative py-4">
                <Container fluid>
                    <Row>
                        {
                            isLoading || isFetching ? <LoadingIndicator /> : (
                                <Col lg="12" className="my-3">

                                    <h3 className="fw-bold">{data?.title || ""}</h3>

                                    {data?.cover_img && <img style={{ width: "100%", height: "400px", objectFit: "fill" }} src={data?.cover_img} />}
                                    <div
                                        className="w-100 my-3"
                                    >
                                        {parse(data?.description)}

                                    </div>
                                </Col>
                            )
                        }
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default TermsAndConditions;
